/**
 * Errore HTTP preservato dal client API.
 *
 * Una richiesta di lettura fallita non e' "nessun dato": React Query deve
 * ricevere un reject per poter mantenere stato, retry e messaggio coerenti.
 */
export class ApiRequestError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly correlationId?: string;
  readonly retryable?: boolean;
  readonly payload?: unknown;

  constructor(
    message: string,
    details: { status: number; code?: string; correlationId?: string; retryable?: boolean; payload?: unknown },
  ) {
    super(message);
    this.name = 'ApiRequestError';
    this.status = details.status;
    this.code = details.code;
    this.correlationId = details.correlationId;
    this.retryable = details.retryable;
    this.payload = details.payload;
  }
}
